export const API_INCOME_GET_CLIENT_LIST_SUCCESS =
    "API_INCOME_GET_CLIENT_LIST_SUCCESS";
export const API_INCOME_GET_CLIENT_LIST_FAIL =
    "API_INCOME_GET_CLIENT_LIST_FAIL";
export const GET_INCOME_GET_CLIENT_LIST = "GET_INCOME_GET_CLIENT_LIST";